import {
    protectedApiCall,
    persUrl,
    sentryAPIErrorV2,
    isMobileTabletCheck,
} from './module_common';

import noUiSlider from 'nouislider';
import {Howl} from 'howler';

export const book = [];
export const UIconfig = {};
export const ref = {};
export const state = {};

export const bookPostProgressAction = {}

export const audioNewData = {
    'total': null,
    'current': null,
    'url': null,
    'audible': null,
}

const playerWrapSelector = ".player-wrap";
const accordionHeaderSelector = "#heading-bc";
const sentSelector = ".sent";
const notSentSelector = ".not-sent";
export const feedbackSelector = ".book-feedback";
export const playerSelector = ".player-4books";
export const tocRowSelector = ".toc-chapter-row";
export const tocWrapSelector = "#table-of-content";

state["playing"] = false;
state["lastApiCall"] = 0;
state["seconds"] = 0;
state["player"] = null;
state["sliderChanging"] = false;
state["timeoutID"] = null;

const Player = function (playlist) {
    this.playlist = playlist;
    this.index = 0;
};

// run Player.step every stepEvery milliseconds
const stepEvery = 500

const doRemoteBookUpdateProgress = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"book_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
            bookPostProgressAction.do(data)
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteBookUpdateProgress",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sending listen progress for book')
            error.name = 'doRemoteBookUpdateProgress fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

const doRemoteArticleUpdateProgress = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"article_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteArticleUpdateProgress",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sending listen progress for article')
            error.name = 'doRemoteArticleUpdateProgress fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

const doRemoteTheUpdateUpdateProgress = function (url, bid, seek) {
    const ep = persUrl(url);
    if (!ep) return;
    const d = {"theupdate_id": bid, "seconds": seek};
    protectedApiCall('POST', ep, d,
        function (data) {
        },
        function (err) {
            const contextData = {
                apicalldata:{
                    function: "doRemoteTheUpdateUpdateProgress",
                    url: ep,
                    method: 'POST',
                    data: JSON.stringify(d),
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error sending listen progress for theupdate')
            error.name = 'doRemoteTheUpdateUpdateProgress fail'
            sentryAPIErrorV2(error, contextData)
        }, 
        true
    );
}

// AUDIO_PLAYER_IS_LOADING is used in a strange way
// ex.: in onpause is set to true
let AUDIO_PLAYER_IS_LOADING = true;
let AUDIO_CONSOLE_ICONS_CLASSES = "";

const doUpdatePlayButton = function(loading) {
    if (loading === AUDIO_PLAYER_IS_LOADING) return;
    AUDIO_PLAYER_IS_LOADING = loading;
    
    if (loading) {
        ref.playBtn.removeClass(AUDIO_CONSOLE_ICONS_CLASSES).addClass(UIconfig.loadingIcon);
    } else {
        ref.playBtn.removeClass(AUDIO_CONSOLE_ICONS_CLASSES).addClass(UIconfig.playIcon);
    }
};

Player.prototype = {
    play: function (index) {
        const self = this;

        AUDIO_PLAYER_IS_LOADING = false;
        doUpdatePlayButton(true);

        index = typeof index === 'number' ? index : self.index;
        self.initSound(index);

        let data = self.playlist[index];
        let sound = data.howl;

        sound.play();
        self.index = index;
    },
    pause: function () {
        const self = this;

        // Get the Howl we want to manipulate.
        const sound = self.playlist[self.index].howl;

        // Pause the sound.
        sound.pause();
        if (state.timeoutID){
            clearTimeout(state.timeoutID)
            state.timeoutID = null
        }
    },
    volume: function (val) {
        let self = this;

        // Update the global volume (affecting all Howls).
        Howler.volume(val);
    },
    skip: function (direction) {
        const self = this;

        // Get the next track based on the direction of the track.
        let index = 0;
        if (direction === 'prev') {
            index = self.index - 1;
            if (index < 0) {
                index = self.playlist.length - 1;
            }
        } else {
            index = self.index + 1;
            if (index >= self.playlist.length) {
                index = 0;
            }
        }
        self.skipTo(index);
    },
    skipTo: function (index) {
        const self = this;
        // Stop the current track.
        if (self.playlist[self.index].howl) {
            self.playlist[self.index].howl.stop();
        }
        // Reset progress.

        // Play the new track.
        self.play(index);
    },
    playerSeek: function (per) {
        const self = this;
        // Get the Howl we want to manipulate.
        let sound = self.playlist[self.index].howl;
        // Convert the percent into a seek position.
        const newPosition = sound.duration() * per;
        updateUiPlayerProgress(newPosition, sound.duration());
        sound.seek(newPosition);
        progressNotify(newPosition, true)
    },
    speed: function (sp) {
        const self = this;
        // Get the Howl we want to manipulate.
        let sound = self.playlist[self.index].howl;
        sound.rate(sp)
    },
    forward: function() {
        const self = this;
        // Get the Howl we want to manipulate.
        const sound = self.playlist[self.index].howl;

        // Determine our current seek position.
        const seek = sound.seek() || 0;
        let newPosition = seek + 10
        if (newPosition > sound.duration()) newPosition = sound.duration()
        sound.seek(newPosition)
        progressNotify(newPosition, true)
    },
    replay: function() {
        const self = this;
        // Get the Howl we want to manipulate.
        const sound = self.playlist[self.index].howl;

        // Determine our current seek position.
        let seek = sound.seek() || 0;
        let newPosition = seek - 10
        if (newPosition < 0) newPosition = 0
        sound.seek(newPosition)
        progressNotify(newPosition, true)
    },
    step: function () {
        const self = this;
        // Get the Howl we want to manipulate.
        const sound = self.playlist[self.index].howl;

        // Determine our current seek position.
        let seek = sound.seek() || 0;
        if (seek && (!seek['_onstop'])) {
            updateUiPlayerProgress(seek, sound.duration());
        }

        if (sound.playing()) {
            doUpdatePlayButton(false);
        } else {
            doUpdatePlayButton(true);
        }

        state.timeoutID = setTimeout(function () {
            self.step();
        }, stepEvery);

        progressNotify(seek); //Call api every X seconds
    },
    initSound: function (index) {
        let startFrom = parseInt(getCurrent())
        const self = this;

        index = typeof index === 'number' ? index : self.index;
        let data = self.playlist[index];

        if (data.howl) {
            return;
        }

        data.howl = new Howl({
            src: [data.file],
            //For Safari
            preload: true,
            html5: true,
            onpause: function () {
                state.playing = false;
                AUDIO_PLAYER_IS_LOADING = true;
                doUpdatePlayButton(true);
                ref.playBtn.removeClass(UIconfig.playClass).addClass(UIconfig.pauseClass)
            },
            onplay: function () {
                state.playing = true;
                ref.playBtn.removeClass(UIconfig.pauseClass).addClass(UIconfig.playClass)
                requestAnimationFrame(self.step.bind(self));
            },
            onload: function () {
                const event = new Event(ref.totalTimeEvent)
                const tot = data.howl.duration();
                event.duration = Math.round(tot)
                ref.totalTime[0].dispatchEvent(event)

                if (startFrom > 0) {
                    data.howl.seek(startFrom);
                }
                
                // end of the book, set start to 0
                if (startFrom >= tot){
                    data.howl.seek(0);
                }
                ref.totalTime.html(formatTime(Math.round(tot)));
            },
            onstop: function () {
                ref.playBtn.removeClass(UIconfig.playClass).addClass(UIconfig.pauseClass)
            },
            onend: function () {
                ref.playBtn.removeClass(UIconfig.playClass).addClass(UIconfig.pauseClass)
                doRemoteUpdateProgress(Math.round(data.howl.duration()));
                state.playing = false;
                // if we don't set to true, we get a spinner on play button
                AUDIO_PLAYER_IS_LOADING = true;
            },
            onseek: function(){
                const sound = self.playlist[self.index].howl;
                doUpdatePlayButton(true);
            }
        });
        data.howl.mobileAutoEnable = "true";

    }
};

const formatTime = function (secs) {
    const minutes = Math.floor(secs / 60) || 0;
    const seconds = (secs - minutes * 60) || 0;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

// this is called every stepEvery milliseconds
const updateUiPlayerProgress = function (seconds, total, updateTotal) {
    updateTotal = updateTotal || false;
    let progress = ((seconds / total) * 100);
    progress = progress || 0

    if (!state.sliderChanging) {
        ref.audioSlider[0].noUiSlider.set(progress)
    }

    ref.elapsedTime.html(formatTime(Math.round(seconds)));
    if (updateTotal) ref.totalTime.html(formatTime(Math.round(total)));
};

const updateSpeedValue = function(value) {
    ref.speedValue.html(value+"x")
    $(".player-speed-dropdown > .dropdown-menu > .dropdown-item").each(function(idx, el){
        if ($(el).data("speed") === value) {
            $(el).addClass("active");
        } else {
            $(el).removeClass("active");
        }

    })
}

const progressNotify = function (seek, force = false) {
    if (!seek) return;

    const intSeek = parseFloat(seek).toFixed(0);
    if (force || !(intSeek % UIconfig.apiRateCall)) {
        if (intSeek !== state.lastApiCall) {
            state.lastApiCall = intSeek;
            doRemoteUpdateProgress(intSeek);
        }
    }
};

const goToPosition = function(value){
    const perc = parseInt(value[0])
    if (state.player !== null){
        state.player.playerSeek(perc/100);
    }
}

const enablePlayerFunctions = function(){
    const c = parseInt(getCurrent()) || 0;
    const t = parseInt(getTotalMinute()) * 60 || 0;
    
    if (t > 0) {
        updateUiPlayerProgress(c, t, true);
    }

    const player = new Player([{file: getUrl()}]);
    player.initSound(player.index);
    state['player'] = player

    ref.audioSlider[0].noUiSlider.on('change', function(val){
        state.sliderChanging = false
        goToPosition(val)
    })
    ref.audioSlider[0].noUiSlider.on('start', function(){
        state.sliderChanging = true
    })
    
    ref.forward.click(function(){
        if (state.playing) {
            forwardThrottle()
        }
    })
    ref.replay.click(function(){
        if (state.playing) {
            replayThrottle()
        }
    })

    ref.playBtn.click(function () {
        if (state.playing) {
            player.pause();
        } else {
            player.play(player.index);
        }
    });

    ref.speedBtnItem.click(function(e){
        const speed = $(e.currentTarget).data("speed")
        updateSpeedValue(Number(speed))
        player.speed(Number(speed))
    })

    // set dropdown-box width
    ref.speedDropdown.on("show.bs.dropdown", function(e){
        const el = $(e.currentTarget)
        const menu = el.find(".dropdown-menu-v2")
        menu.css({width: el.outerWidth()})
    })
};

const throttle = (func, limit) => {
    let inThrottle
    return function() {
        const args = arguments
        const context = this
        if (!inThrottle) {
            func.apply(context, args)
            inThrottle = true
            setTimeout(() => inThrottle = false, limit)
        }
    }
}

const replayThrottle = throttle(() => state.player.replay(), 500);
const forwardThrottle = throttle(() => state.player.forward(), 500);

const setAudioNewData = function(){
    audioNewData.total = "0"
    audioNewData.current = "0"
    audioNewData.url = ""
    audioNewData.audible = false
    const el = $(playerSelector)
    if (el.length == 0) return

    if (el.data("total")){
        audioNewData.total = el.data("total")
    }
    if (el.data("url")){
        audioNewData.url = el.data("url")
    }
    if (el.data("current")){
        audioNewData.current = el.data("current")
    }
    if (el.data("audible")){
        audioNewData.audible = el.data("audible")
    }
}

const getUrl = function(){
    if (audioNewData.url === null) setAudioNewData()
    return audioNewData.url
}

const getTotalMinute = function(){
    if (audioNewData.total === null) setAudioNewData()
    return audioNewData.total
}

const getCurrent = function(){
    if (audioNewData.current === null) setAudioNewData()
    return audioNewData.current
}

const getAudible = function(){
    if (audioNewData.audible === null) setAudioNewData()
    return audioNewData.audible
}

const initAudioSlider = function(start){
    const el = ref.audioSlider[0]
    // do not animate, https://github.com/leongersen/noUiSlider/issues/1115
    noUiSlider.create(el, {
        range: {
            'min': 0,
            'max': 100
        },
        step: 0.1,
        start: start,
        connect: "lower",
        animate: false,
        behaviour: 'snap',
    })
    if (!getAudible()){
        el.noUiSlider.disable()
    }
}

const getContentId = function(){
    return $(playerSelector).data('contid')
}

export const configPlayer = function () {
    ref.elapsedTime = $("#control-elapsed-time");
    ref.audioSlider = $('#audio-slider');
    ref.playBtn = $("#control-action-new");
    ref.forward = $(".player-forward");
    ref.replay = $(".player-replay");
    ref.controls = $(".controls");
    ref.speedBtnItem = $(".pl-spd-item");
    ref.speedValue = $(".speed-value");
    ref.speedDropdown = $(".player-speed-dropdown")

    UIconfig.playClass = 'audio-play';
    UIconfig.pauseClass = 'audio-pause';
    UIconfig.loadingClass = 'audio-loading';

    UIconfig.apiRateCall = 10;
    UIconfig.volume = 0.5;

    ref.totalTime = $("#control-total-time");
    ref.totalTimeEvent = 'totdurationupdate'
};

export const getPlayerRef = function(){
    return ref
}

export function pageSetup(){
    const t = parseInt(getTotalMinute()) * 60 
    const c = parseInt(getCurrent())
    initAudioSlider((c/t*100))
    if (getAudible()){
        enablePlayerFunctions();
    }else{
        updateUiPlayerProgress(0, t, true);
    }
}

export const doRemoteUpdateProgress = function (seek) {
    seek = parseInt(seek);
    if (!seek) return;
    if (state.playing) {
        // Book progress
        if ((typeof bPLEP !== "undefined") && bPLEP) {
            doRemoteBookUpdateProgress(bPLEP, bCode, seek)
        }
        // Article progress
        if ((typeof aPLEP !== "undefined") && aPLEP) {
            doRemoteArticleUpdateProgress(aPLEP, aCode, seek)
        }
        // TheUpdate progress
        if ((typeof thPLEP !== "undefined") && thPLEP) {
            doRemoteTheUpdateUpdateProgress(thPLEP, thCode, seek)
        }
    }
};

// catch all click on player wrap
export const attachPlayerClick = function(canRead, canReadOnClickFuncion, cantReadClickFunction){
    $(playerWrapSelector).click(function(e){
        if (canRead){
            canReadOnClickFuncion(e)
            return
        }
        const target = $(e.target)
        const header = target.parents(accordionHeaderSelector).length
        if (header !== 0) return    // exclude accordion header click
        cantReadClickFunction(e)
    })
}

// works for player and reader icons
export const attachFeedbackClick = function(canRead, sendLikePromise){{
    if (!canRead) return
    $(feedbackSelector).click(function(e){
        const currTarget = $(e.currentTarget)
        let value = Number(currTarget.data("feedback"))
        if (currTarget.children(sentSelector+".current").length == 1) {
            value = 0
        }
        sendLikePromise(getContentId(), value)
            .then(likeVal => {
                switch (likeVal) {
                    case 1:
                        setLikedIcon() 
                        break;
                    case -1:
                        setDislikedIcon()
                        break;
                    default:
                        clearLikedDislikedIcon()
                        break;
                }
            })
    })
}}

export const closeMobileToc = function(){
    if (isMobileTabletCheck()){
        $(tocWrapSelector).collapse('hide')
    }
}

export const setLikedIcon = function(){
    const targetUp = $(feedbackSelector+"[data-feedback=1]")
    const targetDown = $(feedbackSelector+"[data-feedback=-1]")
    targetUp.children(sentSelector).addClass("current")
    targetUp.children(notSentSelector).removeClass("current")
    targetDown.children(sentSelector).removeClass("current")
    targetDown.children(notSentSelector).addClass("current")
}

export const setDislikedIcon = function(){
    const targetUp = $(feedbackSelector+"[data-feedback=1]")
    const targetDown = $(feedbackSelector+"[data-feedback=-1]")
    targetUp.children(sentSelector).removeClass("current")
    targetUp.children(notSentSelector).addClass("current")
    targetDown.children(sentSelector).addClass("current")
    targetDown.children(notSentSelector).removeClass("current")
}

export const clearLikedDislikedIcon = function(){
    const targetUp = $(feedbackSelector+"[data-feedback=1]")
    const targetDown = $(feedbackSelector+"[data-feedback=-1]")
    targetUp.children(sentSelector).removeClass("current")
    targetUp.children(notSentSelector).addClass("current")
    targetDown.children(sentSelector).removeClass("current")
    targetDown.children(notSentSelector).addClass("current")
}

export const setTocChapterPosition = function (chapNum) {
    const currentTocEl = $(tocRowSelector+'[data-chapterid="'+chapNum+'"]')
    const wrap = $(tocWrapSelector)
    const headingEl = $(accordionHeaderSelector)
    const borderHeight = 1
    if (currentTocEl.length){
        wrap.animate({
            scrollTop: currentTocEl[0].offsetTop - headingEl.outerHeight() + borderHeight
        }, 300)
    }else{
        const contextData = {
            mydata:{
                function: "setTocChapterPosition",
                chapNum: chapNum,
                uid: UIDg,
            }
        }
        const error = new Error('TOC element do not exist')
        error.name = 'setTocChapterPosition fail'
        sentryAPIErrorV2(error, contextData)
    }
}

export const updateUiPlayerSlider = function(second, total){
    updateUiPlayerProgress(second, total, true)
}
